module.exports = __webpack_public_path__ + "img/375.3300fd2e.jpg";